
import Vue, { PropType } from 'vue'
import { Block } from '@interfaces/BlockTypes'
import AppActions from '@constants/AppActions'

export default Vue.extend({
  name: 'CommonVsCompetitorTable',
  props: {
    block: {
      type: Object as PropType<Block>,
      required: true,
    },
  },
  computed: {
    isMobileView(this: { $vuetify: any }) {
      const mobileThreshold = 956
      return this.$vuetify.breakpoint.width < mobileThreshold
    },
  },
  methods: {
    async ctaButtonClicked() {
      if (this.block?.ctaButton?.enableTracking) {
        await this.$store.dispatch(AppActions.TRACK_SIGN_UP_EVENT, {
          context: this,
          location: this.block?.ctaButton?.trackingLocation,
          link: this.block?.ctaButton?.link || null,
        })
      }
    },
  },
})
